export default __webpack_public_path__ + "static/media/19.8d27f790.jpg";